<template>
    <div class="dashboard">
        <div class="dashboard__line">
            <div class="chart chart_default">
                <p>Orders quantity</p>
                <canvas width="100%" height="100%" class="chart-js"></canvas>
            </div>
            <div class="chart chart_default">
                <p>Income / profit</p>
                <canvas width="100%" height="100%" class="chart-js2"></canvas>
            </div>
            <div class="chart chart_default">
                <p>Percent of canceled orders</p>
                <canvas width="100%" height="100%" class="chart-js"></canvas>
            </div>
            <div class="chart chart_default">
                <p>Predicted / fact</p>
                <canvas width="100%" height="100%" id="chart-plan"></canvas>
            </div>
            <div class="chart chart_default">
                <p>Percent of canceled orders</p>
                <canvas width="100%" height="100%" class="chart-js"></canvas>
            </div>
        </div>

        <div class="dashboard__line dashboard__line_bottom">
            <div class="dashboard__left">
                <div style="display: flex; width: 100%">
                    <div style="width: 420px;">
                        <div class="chart chart_full">

                            <p>Masters online</p>
                            <canvas width="100%" height="90%" id="chart4"></canvas>
                        </div>
                    </div>

                    <div style="width:100%;margin-left:2%">
                        <div class="info">
                            <div class="info__item info_head">
                                <div  class="info__column info__working">
                                    <span>Working partners</span>
                                </div>
                                <div class="info__column info__sold">
                                    <span>Sold orders</span>
                                </div>
                                <div class="info__column info__no-orders">
                                    <span>Partners with no orders</span>
                                </div>
                            </div>

                            <div class="info__item">
                                <div class="info__column info__working">
                                    <a href="javascipr:void" :title="'today/yesterday'">67/80</a>
                                </div>
                                <div class="info__column info__sold">
                                    <a href="javascipr:void" :title="'today/yesterday'">€3000/€4500</a>
                                </div>
                                <div class="info__column info__no-orders">
                                <a href="javascipr:void" :title="'today/yesterday'">20/10</a>
                                </div>
                            </div>
                            </div>
                            <div class="info">
                                <div class="info__item info_head">
                                    <div class="info__column info__new-clients">
                                        <span>New clients</span>
                                    </div>
                                    <div class="info__column info__by-ads">
                                        <span>Registered by ads</span>
                                    </div>
                                    <div class="info__column info__by-refferal">
                                        <span>Registered by a referral link</span>
                                    </div>
                                </div>

                                <div class="info__item">
                                    <div class="info__column info__new-clients">
                                        <a href="javascipr:void" :title="'today/yesterday'">67/75</a>
                                    </div>
                                    <div class="info__column info__by-ads">
                                        <a href="javascipr:void" :title="'today/yesterday'">57/75</a>
                                    </div>
                                    <div class="info__column info__by-refferal">
                                        <a href="javascipr:void" :title="'today/yesterday'">10/30</a>
                                    </div>
                                </div>
                            </div>
                            <div class="info">
                                <div class="info__item info_head">
                                    <div class="info__column info__avg">
                                        <span>An average order rating</span>
                                    </div>
                                    <div class="info__column info__avg">
                                        <span>An average master rating</span>
                                    </div>
                                </div>

                                <div class="info__item">
                                    <div class="info__column info__avg">
                                        <a href="javascipr:void" :title="'today/yesterday'">4.5/4.7</a>
                                    </div>
                                    <div class="info__column info__avg">
                                        <a href="javascipr:void" :title="'today/yesterday'">4.1/4.2</a>
                                    </div>

                                </div>
                            </div>

                            <div>
                            <!-- <ul class="tech-info">
                                <li>App: <span class="tech-info_span">200</span></li>
                                <li>Landing page: <span class="tech-info_span">500</span></li>
                                <li>Backend: <span class="tech-info_span">200</span></li>
                                <li>Ads: <span class="tech-info_span">running</span></li>
                            </ul> -->
                        </div>
                    </div>
                </div>

            </div>

            <div class="map-chart small_mt" id="chart-map"></div>
        </div>
    </div>
</template>

<script>
import { Chart } from 'chart.js'
import moment from 'moment'

import { globalConfig } from '@/config'
import GoogleMapsLoader from 'google-maps'
// json
import austria from './austria'
import northEast from './json/norstEast'
import center from './json/center'
import north from './json/north'
import east from './json/east'
import south from './json/south'

GoogleMapsLoader.KEY = globalConfig.googleMapsKey
GoogleMapsLoader.LANGUAGE = globalConfig.lang

function newDate(days) {
    return moment().add(days, 'h').toDate()
}

Chart.defaults.global.legend.display = false

// lightgrey rgb(220,220,220)
// silver rgb(192,192,192)
// darkrey rgba(105,105,105)

const colors = {
    firstMain: '#71a95a',
    secondMain: 'rgba(113, 189, 74, 0.7)',

    darkgrey: 'rgba(105,105,105)',
}

export default {
    data() {
        return {
            dataset: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [
                    {
                        label: 'My First dataset',
                        backgroundColor: colors.firstMain,
                        borderColor: colors.firstMain,
                        data: [0, 10, 5, 2, 20, 30, 45],
                        order: 2,
                    },
                    {
                        label: 'My Second dataset',
                        backgroundColor: colors.secondMain,
                        borderColor: colors.secondMain,
                        data: [2, 11, 4, 3, 21, 20, 35],
                        order: 3,
                    },
                    {
                        data: [30, 30, 30, 30, 30, 30, 30, 30],
                        type: 'line',
                        order: 1,
                        backgroundColor: 'rgba(105,105,105, 0)',
                        borderColor: 'rgba(105,105,105)',
                    },
                ],
            },
        }
    },
    methods: {
        update() {
            this.chart.data.datasets.forEach((element) => {
                element.data = element.data.map((e) => {
                    let v = e
                    return ++v
                })
            })

            this.chart.update()
        },
    },
    mounted() {
        const ctx = document.querySelectorAll('.chart-js')
        ctx.forEach((element) => {
            // eslint-disable-next-line no-new
            new Chart(element.getContext('2d'), {
                type: 'bar',
                data: this.dataset,
                options: {
                    scales: {
                        xAxes: [{
                            stacked: true,
                        }],
                        yAxes: [{
                            stacked: true,
                        }],
                    },
                },
            })
        })

        const chart2 = document.querySelectorAll('.chart-js2')
        chart2.forEach((element) => {
            // eslint-disable-next-line no-new
            new Chart(element.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: colors.firstMain,
                            borderColor: colors.firstMain,
                            data: [15, 10, 15, 11, 14, 9, 100],
                            order: 2,
                        },
                        {
                            label: 'My Second dataset',
                            backgroundColor: colors.secondMain,
                            borderColor: colors.secondMain,
                            data: [20, 11, 13, 12, 21, 20, 105],
                            order: 3,
                        },
                        {
                            data: [15, 15, 15, 15, 15, 15, 15, 15],
                            type: 'line',
                            order: 1,
                            backgroundColor: 'rgb(255, 255, 255, 0)',
                            borderColor: 'rgba(105,105,105)',
                        },
                    ],
                },
                options: {
                    scales: {
                        xAxes: [{
                            stacked: true,
                        }],
                        yAxes: [{
                            stacked: true,
                        }],
                    },
                },
            })
        })

        const ctx4 = document.getElementById('chart4').getContext('2d')
        this.chart = new Chart(ctx4, {
            type: 'pie',
            data: {
                datasets: [{
                    data: [
                        60,
                        412,
                    ],
                    backgroundColor: [
                        colors.secondMain,
                        colors.firstMain,
                    ],
                },
                ],
                labels: [
                    'Online',
                    'Offline',
                ],
            },
        })

        const timeFormat = 'HH:mm'
        const ctx5 = document.getElementById('chart-plan').getContext('2d')
        this.chart = new Chart(ctx5, {
            type: 'line',
            data: {
                labels: [ // Date Objects
                    newDate(0),
                    newDate(1),
                    newDate(2),
                    newDate(3),
                    newDate(4),
                    newDate(5),
                    newDate(6),
                ],
                datasets: [
                    {
                        label: 'My First dataset',
                        backgroundColor: colors.secondMain,
                        borderColor: colors.secondMain,
                        fill: false,
                        data: [
                            10,
                            15,
                            30,
                            60,
                            120,
                            130,
                        ],
                    },
                    {
                        label: 'My Second dataset',
                        backgroundColor: colors.firstMain,
                        borderColor: colors.firstMain,
                        fill: false,
                        data: [
                            20,
                            15,
                            50,
                            40,
                            70,
                        ],
                    },
                ],
            },
            options: {
                title: {
                    text: 'Chart.js Time Scale',
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        time: {
                            parser: timeFormat,
                            // round: 'day'
                            tooltipFormat: 'll HH:mm',
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Date',
                        },
                    }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'value',
                        },
                    }],
                },
            },
        })

        this.map = new window.google.maps.Map(
            document.getElementById('chart-map'),
            {
                center: { lat: 48.209976, lng: 16.373740 },
                zoom: 10.7,
                disableDefaultUI: true,
                clickableIcons: false,
                maxZoom: 18,
            },
        )

        const austria_coords = austria
        const austriaPath = new window.google.maps.Polyline({
            path: austria_coords,
            geodesic: true,
            strokeColor: colors.darkgrey,
            strokeOpacity: 1.0,
            strokeWeight: 2,
        })
        austriaPath.setMap(this.map)

        // eslint-disable-next-line no-undef
        const northEastBlock = new google.maps.Polygon({
            paths: northEast,
            strokeColor: colors.secondMain,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: colors.secondMain,
            fillOpacity: 0.35,
        })
        northEastBlock.setMap(this.map)

        // eslint-disable-next-line no-undef
        const northBlock = new google.maps.Polygon({
            paths: north,
            strokeColor: 'rgb(153, 17, 153)',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: 'rgb(153, 17, 153)',
            fillOpacity: 0.35,
        })
        northBlock.setMap(this.map)

        // eslint-disable-next-line no-undef
        const centerBlock = new google.maps.Polygon({
            paths: center,
            strokeColor: 'rgb(52, 147, 255)',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: 'rgb(52, 147, 255)',
            fillOpacity: 0.35,
        })
        centerBlock.setMap(this.map)

        // eslint-disable-next-line no-undef
        const eastBlock = new google.maps.Polygon({
            paths: east,
            strokeColor: 'rgba(255,215,0)',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: 'rgba(255,215,0)',
            fillOpacity: 0.35,
        })
        eastBlock.setMap(this.map)

        // eslint-disable-next-line no-undef
        const southBlock = new google.maps.Polygon({
            paths: south,
            strokeColor: 'red',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: 'red',
            fillOpacity: 0.35,
        })
        southBlock.setMap(this.map)
    },
}
</script>
<style lang="scss" scoped>
.dashboard {
    height: calc(100% - 70px);
    width: 100%;
    border-radius: 8px;
    padding: 20px 0 20px 20px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

    &__line {
        display:flex;
        width: 100%;
        height: auto;

        &_bottom {
            display:flex;
            width: 100%;
            height: 100%;
            max-height: 300px;
            margin-top: 20px;
        }
    }

    &__left {
        width: 100%;
        max-width: 60%;
        height: 430px;
        position: relative;
        display: flex;
        margin-top: 15px;
    }
}

.chart {
    width: 100%;
    height: 300px;
    margin-right: 2%;

    p {
        font-weight: bold;
        margin: 0;
        color: dimgray;
        font-size: 16px;
    }

    &_w50 {
        max-width: 18%;
    }

    &_mt {
        margin-top: 20px;
    }

    &_default {
        max-width: 18%;
    }

    &_full {
        max-width: 100%;
    }

}

.map-chart {
    width: 100%;
    max-width: 38%;
    height: 421px;
    background-color: lightgreen;
    margin-left: 10px;
    margin-top: 15px;
}

.charts {
    display: flex;
    width: 100%;
    height: 300px;
}

.info {
    background-color: #fff;
    height: auto;
    overflow-y: auto;
    margin-bottom: 20px;
    margin-right: 10px;
    box-sizing: border-box;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

    &__item {
        display: flex;
        font-size: 14px;
        color: #444;
        margin-bottom: 5px;
        padding: 15px;
        &:first-child {
            background-color: rgba(97, 66, 45, 0.05);
        }
    }

    &_head {
        font-weight: 600;
        font-size: 15px;
        color: #000;
        padding: 15px;
    }

    &__working {
        width: 22%;
    }

    span {
        color: dimgray;
    }

    &__sold {
        width: 22%;
    }

    &__no-orders {
        width: 30%;
    }

    &__avg {
        width: 35%;
    }

    &__new-clients,
    &__by-ads  {
        width: 22%;
    }

    &__by-refferal {
        width: 30%;
    }
}

.tech-info {
    display: flex;
    list-style-type: none;
    padding: 0;
    position: absolute;
    bottom: 0;

    &_error {
        color: darkred;
    }

    &_ok {
        color: rgb(52, 147, 255);
    }

    &_span {
        font-weight: bold;
        color: rgb(105,105,105);
    }
}

.tech-info li {
    margin-right: 25px;
}
</style>

<style>
.chart_half {
    max-width: 48% !important;
}

canvas {
    height: 100% !important;
    width: 100% !important;
    max-height: 300px !important;
    object-fit: contain;
}

.header-logo {
    padding-left: 13%;
}
</style>
